module.exports = __webpack_public_path__ + "fonts/31E180_3_0.e5327d0.eot";